export const isDesktop = () => window.innerWidth >= 1024;
export const isMobile = () => window.innerWidth < 768;
